import * as Icons from "heroicons-react";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  useAddBrandMutation,
  useBrandsCountQuery,
  useBrandsQuery,
  useDeleteBrandMutation,
} from "../../services/brandApi";
import Header from "../Common/Header/Header";
import LoadingModal from "../Common/Modal/LoadingModal";
import PackageModal from "../Common/Modal/PackageModal";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import { apiUniqueErrHandle } from "../Utility/Utility";
import "./Brand.css";

const Brand = () => {
  const auth = signInUser();
  const lang = useSelector((state) => state.languageReducer);

  const aamarId = auth?.aamarId;
  const [AddBrand] = useAddBrandMutation();
  const { data, isLoading, isFetching } = useBrandsQuery({ aamarId });

  useEffect(() => {
    isFetching ? setLoader(true) : setLoader(false);
  }, [data, isLoading, isFetching]);

  useEffect(() => {
    data ? setLoader(false) : setLoader(true);
  }, [data]);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({});
  const [deleteBrand] = useDeleteBrandMutation();
  const { data: countData } = useBrandsCountQuery();
  const [modalVisible, setModalVisible] = useState(false);
  const closeModal = () => setModalVisible(false);

  // console.log(data)

  let navigate = useNavigate();
  let i = 1;

  const [loader, setLoader] = useState(false);
  const handleLoaderClose = () => setLoader(false);

  // console.log("Count DATA", countData);
  // console.log("brandLimited", auth?.package?.brandLimited);
  const onSubmit = async (data) => {
    //@ts-ignore
    if (countData >= auth?.package?.brandLimited) {
      setModalVisible(true);
      return;
    } else {
      const requestData = {
        ...data, // Spread the existing data
        aamarId, // Add aamarId
      };
      setLoader(true);
      // console.log(requestData);

      try {
        const response = await AddBrand(requestData);
        if (response) {
          // console.log(response);
          if (response?.error) {
            apiUniqueErrHandle(response);
          } else {
            reset({
              name: "",
              photo: "",
              company: "",
              // status: "",
            });
            // console.log(response?.data?.message);
            return navigate("/brand");
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoader(false);
      }
    }
  };

  const deleteHandler = async (id) => {
    const result = await Swal.fire({
      title: "Are you Sure?",
      text: "Delete this Brand?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      const res = await deleteBrand(id);
      if (res?.error) {
        Swal.fire(
          "Error!",
          res?.error?.data?.message || "Failed to delete brand.",
          "error"
        );
      } else {
        Swal.fire("Deleted!", "Brand has been deleted.", "success");
      }
    }
  };

  const handleReset = () => {
    reset({
      name: "",
      photo: "",
      company: "",
    });
  };
  return (
    <div>
      <div className="container-fluid">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title={lang?.brand}></Header>

            <div className="row mt-2">
              <div className="col-md-12    mt-md-2 mb-2">
                <div className="float-end">
                  <Link
                    className="btn btn-dark mb-2 float-end me-2 "
                    to="/brand/importBrand"
                  >
                    <Icons.PlusOutline size={22}></Icons.PlusOutline>{" "}
                    {lang?.importBrand}
                  </Link>
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="sticky-md-top ">
                  <div className="card mt-2">
                    <div className="card-header">
                      <h5 className="card-title">
                        {data?._id ? "Update" : "Add"} Brand
                      </h5>
                    </div>
                    <div className="card-body ">
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row mb-3">
                          <div className="form-group col-12  mb-3">
                            <label htmlFor="inputCustomer">Brand Name</label>
                            <input
                              {...register("name", {
                                required: "* This Field is Required", // Custom error message
                              })}
                              type="text"
                              className="form-control"
                              id="inputCustomer"
                              aria-describedby="emailHelp"
                              placeholder="Brand Name"
                            />
                            {errors.name && (
                              <span className="text-danger mt-2">
                                {errors.name.message}
                              </span>
                            )}
                            <small
                              id="emailHelp"
                              className="form-text text-muted"
                            >
                              We'll never share your email with anyone else.
                            </small>
                          </div>
                          <div className="form-group col-12  mb-3">
                            <label htmlFor="inputMC"> company</label>
                            <input
                              {...register("company")}
                              type="text"
                              className="form-control"
                              id="phone"
                              placeholder="company"
                            />
                          </div>
                          <div className="form-group col-12  mb-3">
                            <label htmlFor="MCId">status</label>
                            <select
                              {...register("status")}
                              className="form-control"
                              id="address"
                              placeholder="Status"
                            >
                              <option value="active">active</option>
                              <option value="inactive">inactive</option>
                            </select>
                          </div>
                        </div>
                        <button
                          type="reset"
                          onClick={handleReset}
                          className="btn btn-outline-dark col-3 col-md-4"
                        >
                          Reset
                        </button>
                        <button
                          type="submit"
                          className="btn btn-dark col-8 ms-1 col-md-7"
                        >
                          {data?._id ? (
                            <>
                              <Icons.SaveOutline></Icons.SaveOutline>
                            </>
                          ) : (
                            <>
                              <Icons.Plus> </Icons.Plus>
                            </>
                          )}
                          Brand
                        </button>
                      </form>
                    </div>
                  </div>
                  {/* <CsvImporter setCsvData={setCsvData} handleImportButton={handleImportButton} title="Customer"></CsvImporter> */}
                </div>
              </div>

              <div className="col-md-8 ">
                {/* <nav aria-label="Customer Pagination" className="">
                  <ul className="pagination pagination-md">
                    <li className="page-item">
                      <select
                        className="form-control"
                        onChange={(e) => setSize(e.target.value)}
                      >
                        <option
                          value="50"
                          selected={size === 25 ? "selected" : ""}
                        >
                          25
                        </option>
                        <option
                          value="50"
                          selected={size === 50 ? "selected" : ""}
                        >
                          50
                        </option>
                        <option
                          value="100"
                          selected={size === 75 ? "selected" : ""}
                        >
                          75
                        </option>
                        <option
                          value="150"
                          selected={size === 150 ? "selected" : ""}
                        >
                          100
                        </option>
                      </select>
                    </li>
                    {[...Array(pageCount).keys()].map((number) => (
                      <li
                        className={
                          page === number ? "page-item disabled" : "page-item"
                        }
                        key={number}
                      >
                        <button
                          onClick={() => setPage(number)}
                          className="page-link"
                          tabIndex={page === number ? "-1" : ""}
                        >
                          {number + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                </nav> */}
                <div
                  className="mt-4 mt-md-0"
                  // style={{ maxHeight: "400px", overflowY: "auto" }}
                >
                  <table className="table table-striped   ">
                    <thead>
                      <tr>
                        <th className="ps-md-4 " scope="col">
                          #
                        </th>
                        <th scope="col">Brand Name</th>
                        <th scope="col">Comapny Name</th>
                        <th scope="col">Status</th>
                        <th scope="col">ActionBtn</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data ? (
                        data.map((Brand) => (
                          <tr key={Brand._id}>
                            <th className="ps-md-4" scope="row">
                              {i++}
                            </th>
                            <td>{Brand.name}</td>
                            <td>{Brand.company}</td>
                            <td>{Brand.status}</td>
                            <td>
                              <Link to={`/brand/update/${Brand._id}`}>
                                <Icons.PencilAltOutline
                                  className="icon-edit"
                                  size={20}
                                ></Icons.PencilAltOutline>
                              </Link>
                              {auth?.type === "admin" && (
                                <Icons.TrashOutline
                                  className="icon-trash"
                                  onClick={() => deleteHandler(Brand._id)}
                                  size={20}
                                />
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="text-center" colSpan={5}>
                            No Brand Data
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Toaster position="bottom-right" /> */}
      {/* Package Info Modal */}
      <PackageModal show={modalVisible} handleClose={closeModal} />{" "}
    </div>
  );
};

export default Brand;
